"use client";

import { c as _c } from "react/compiler-runtime";
import ResponsiveModal from "@/components/custom/ResponsiveModal";
import { DashboardPromptInput } from "@/app/(v2)/dashboard/_components/DashboardPromptInput";
import { ASK_CADDIE_LABEL } from "@/lib/caddie";
interface AskCaddieModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export function AskCaddieModal(t0) {
  const $ = _c(6);
  const {
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = <DashboardPromptInput autoFocus={true} onSubmitted={() => onOpenChange(false)} />;
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onOpenChange || $[3] !== open || $[4] !== t1) {
    t2 = <ResponsiveModal open={open} onOpenChange={onOpenChange} title={ASK_CADDIE_LABEL} contentClass="sm:max-w-[640px]" innerClass="bg-transparent shadow-none p-0 gap-0" hideCloseButton={true}>{t1}</ResponsiveModal>;
    $[2] = onOpenChange;
    $[3] = open;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}